// extracted by mini-css-extract-plugin
module.exports = {"container":"checklist_container__2CgHD","title":"checklist_title__36361","items":"checklist_items__3SOo4"};